import React, {
  useState,
  useContext
} from 'react';
import {
  Route,
  Switch,
  useRouteMatch
} from 'react-router-dom';
import ApmHeader from '../../template/ApmHeader';
import context from './context';
import PatientPage from './pages/patient-page/PatientPage'
import RegistrationPage from './pages/registration-page/RegistrationPage'
import HomePage from './pages/home-page/HomePage';
import ClinicPage from './pages/clinic-page/ClinicPage'

const Apm = () => {
  const [ patient, setPatient ] = useState({});

  const match = useRouteMatch();
  const apmContext = useContext(context);

  apmContext.setData = function(args) {
    setPatient(args);
  };
  apmContext.data = patient;
  return (
    <div>
      <ApmHeader />
      <div style={ { padding: 20, marginTop: 20 } }>
        <Switch>
          <Route path={ `${ match.path }/registration` }>
            <RegistrationPage />
          </Route>
          <Route path={ `${ match.path }/search` }>
            <PatientPage />
          </Route>
          <Route path={ `${ match.path }/clinic` } render={ props => <ClinicPage { ...props } /> } />
          <Route path='/apm'>
            <HomePage />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Apm;
